import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface Props {
  email: string | null;
  provider: string | null;
}

const SecurityCard = ({ email, provider }: Props) => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const isOAuth = provider && provider !== "email";

  if (isOAuth) return null;

  const handleReset = async () => {
    if (!email) return;
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password",
    });
    setLoading(false);
    if (error) {
      toast({ title: "Couldn't send reset email", description: error.message, variant: "destructive" });
      return;
    }
    toast({
      title: "Reset email sent",
      description: `Check ${email} for a link to set a new password.`,
    });
  };

  return (
    <div className="bg-card border border-border p-6 w-full space-y-4">
      <div>
        <h3 className="text-foreground font-medium">Password</h3>
        <p className="text-xs text-muted-foreground mt-1">
          {isOAuth
            ? `You sign in with ${provider}. Manage your password in your ${provider} account.`
            : "We'll send a link to your email to set a new password."}
        </p>
      </div>
      {!isOAuth && (
        <Button
          variant="outline"
          className="rounded-full"
          onClick={handleReset}
          disabled={loading || !email}
        >
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Send password reset email
        </Button>
      )}
    </div>
  );
};

export default SecurityCard;
